const sectionProductGridCss = `
[data-type='section-product-grid'] [data-attribute='product-grid-container'] {
  padding: 40px 0;
}

[data-type='section-product-grid'] .wrap-produc-grid {
  font-size: 16px;
}

[data-type='section-product-grid'] .wrap-produc-grid .header-grid {
  text-align: center;
  margin-bottom: 20px !important;
}

[data-type='section-product-grid'] .wrap-produc-grid .header-grid .wrap-stars {
  display: flex;
  justify-content: center;
  gap: 4px;
  color: #c4c4c4;
}

[data-type='section-product-grid'] .wrap-produc-grid .header-grid .wrap-stars svg {
  fill: #c4c4c4;
}

[data-type='section-product-grid'] .wrap-produc-grid .header-grid .wrap-stars[data-value='1'] svg:nth-child(-n + 1),
[data-type='section-product-grid'] .wrap-produc-grid .header-grid .wrap-stars[data-value='2'] svg:nth-child(-n + 2),
[data-type='section-product-grid'] .wrap-produc-grid .header-grid .wrap-stars[data-value='3'] svg:nth-child(-n + 3),
[data-type='section-product-grid'] .wrap-produc-grid .header-grid .wrap-stars[data-value='4'] svg:nth-child(-n + 4),
[data-type='section-product-grid'] .wrap-produc-grid .header-grid .wrap-stars[data-value='5'] svg:nth-child(-n + 5) {
  color: #f0b100;
  fill: #f0b100;
}

[data-type='section-product-grid'] .wrap-produc-grid .header-grid .title-gird {
  font-size: 24px;
  font-weight: bold !important;
}

[data-type='section-product-grid'] .wrap-produc-grid .body-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  overflow-x: auto;
}

[data-type='section-product-grid'] .wrap-produc-grid .body-grid .item-product {
  text-decoration: none;
  display: block;
  width: calc((100% - 40px) / 3);
}

[data-type='section-product-grid'] .wrap-produc-grid .body-grid .item-product .wrap-img {
  overflow: hidden;
  border-radius: 6px;
  margin-bottom: 20px !important;
  position: relative;
  aspect-ratio: 1/1;
}

[data-type='section-product-grid'] .wrap-produc-grid .body-grid .item-product .wrap-img img {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-product-grid'] .wrap-produc-grid .body-grid .item-product .wrap-content h2,
[data-type='section-product-grid'] .wrap-produc-grid .body-grid .item-product .wrap-content h3 {
  font-size: 16px;
}

@container (max-width: 768px) {
  [data-type='section-product-grid'] [data-attribute='product-grid-container'] {
    padding: 16px 0;
  }

  [data-type='section-product-grid'] .wrap-produc-grid {
    font-size: 14px;
  }

  [data-type='section-product-grid'] .wrap-produc-grid .header-grid .title-gird {
    font-size: 16px;
  }

  [data-type='section-product-grid'] .wrap-produc-grid .body-grid {
    flex-wrap: nowrap;
  }

  [data-type='section-product-grid'] .wrap-produc-grid .body-grid .item-product {
    width: 100%;
    flex-shrink: 0;
  }
}
`;

export default sectionProductGridCss;
